import { buttonVariants } from '../components/button';
import { cn } from '../lib/utils';
import { ShellLink } from './link';

export interface SectionLink {
  id: string;
  label: string;
  href: string;
}

/**
 * The views (sections) of one settings area as links, styled like the SegmentedControl: for pages where each
 * section is its own deep-linkable route. It sits under the tab bar and is never a second tab row.
 */
export function SectionLinks({ label, sections, activeId }: { label: string; sections: readonly SectionLink[]; activeId: string }) {
  return (
    <nav aria-label={label} className="flex flex-wrap gap-2">
      {sections.map((section) => (
        <ShellLink
          key={section.id}
          href={section.href}
          aria-current={section.id === activeId ? 'page' : undefined}
          className={cn(buttonVariants({ variant: 'outline', size: 'sm' }), section.id === activeId && 'border-primary bg-primary/10 text-primary hover:bg-primary/15')}
        >
          {section.label}
        </ShellLink>
      ))}
    </nav>
  );
}
